(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* ---------- Hash scroll-to-card ---------- */
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  /* ---------- Column count enforcement (CSS-proof, inline !important) ---------- */
  function _applyCustomColumns(rl) {
    if (!rl) return;
    const desktop = parseInt(rl.style.getPropertyValue('--custom-desktop-columns'), 10) || 4;
    const mobile  = parseInt(rl.style.getPropertyValue('--custom-mobile-columns'), 10)  || 2;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    // Reach into Findter-rendered grids and the theme grids alike
    const selector = 'ul.product-grid, .main-collection-grid > ul, .main-collection-grid .product-grid, .search-filters__results ul, .search-filters__results .product-grid';
    document.querySelectorAll(selector).forEach(function (g) {
      // The shopper's own view choice beats the section default.
      const view = g.getAttribute('product-grid-view');
      if (!isMobile && view === 'zoom-out') {
        g.style.removeProperty('grid-template-columns');
        return;
      }
      const cols = isMobile ? (view === 'mobile-single' ? 1 : mobile) : desktop;
      g.style.setProperty('grid-template-columns', 'repeat(' + cols + ', minmax(0, 1fr))', 'important');
    });
  }

  function _initCustomColumns() {
    document.querySelectorAll('results-list').forEach(function (rl) {
      _applyCustomColumns(rl);
      // childList catches re-rendered grids (filtering, pagination);
      // product-grid-view catches the shopper flipping the layout toggle.
      const mo = new MutationObserver(function () { _applyCustomColumns(rl); });
      mo.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['product-grid-view'],
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _initCustomColumns);
  } else {
    _initCustomColumns();
  }
  window.addEventListener('resize', function () {
    document.querySelectorAll('results-list').forEach(_applyCustomColumns);
  });


  } catch(e) { console.error(e); }
})();
})();
